import TopNavBar from '../components/TopNavBar'
import Loader from './Loader'
import Toast from './Toast'
import Sidebar from 'components/Sidebar'
import { useContext } from 'react'
import AuthContext from 'context/AuthContext'

function MainLayout ({ children }) {
  const { sidebarStatus } = useContext(AuthContext)

  return (
    <div className='main_wrap'>
      <Loader />
      <Toast />
      <Sidebar />
      <div
        className={`right_panel  ${
          sidebarStatus === 'open' ? 'xl:ml-[280px] lg:ml-[220px] ml-0' : ''
        }  `}
      >
        <TopNavBar />
        {children}
      </div>
    </div>
  )
}

export default MainLayout
